import { render, staticRenderFns } from "./SocialFeedPagination.vue?vue&type=template&id=7f26b906"
import script from "./SocialFeedPagination.vue?vue&type=script&lang=ts"
export * from "./SocialFeedPagination.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports